export function getRandomIntInclusive(min, max) {
  let randomNumber = Math.random()

  randomNumber = min + (max - min) * randomNumber
  return randomNumber
}
